<div class="py-2">
  <table
    mat-table
    matSort
    [matSortActive]="activeSort?.active ?? 'created_at'"
    [matSortDirection]="activeSort?.direction ?? 'desc'"
    [dataSource]="dataSource"
    (matSortChange)="onSortChange($event)">
    <!-- Country Column -->
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
      <td mat-cell *matCellDef="let element" data-label="Country">
        {{ element.country }}
      </td>
    </ng-container>

    <!-- Currency Column -->
    <ng-container matColumnDef="currency">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Currency</th>
      <td mat-cell *matCellDef="let element" data-label="Currency">
        {{ element.currency }}
      </td>
    </ng-container>

    <!-- Balance Column -->
    <ng-container matColumnDef="balance">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Balance</th>
      <td mat-cell *matCellDef="let element" data-label="Balance">
        {{ element.balance }}
      </td>
    </ng-container>

    <!-- Created Date Column -->
    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
      <td mat-cell *matCellDef="let element" data-label="Created Date">
        {{ element.created_at | date: 'dd/MM/yyyy' }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      class="custom-mat-btn"
      *matRowDef="let row; columns: displayedColumns; let element"></tr>
  </table>
  <mat-paginator
    showFirstLastButtons
    [pageIndex]="page"
    [length]="total"
    [pageSize]="limit"
    [pageSizeOptions]="[10, 20, 50, 100, 200]"
    (page)="onPageChange($event)"></mat-paginator>
</div>
